import LogoViewer from '../LogoViewer';
import { Text, TextWrapper } from './styled';
import { externalLink } from 'api/log/saveLog.api';
import useCustomMutate from 'hook/useQuery/useCustomMutate';
import { CheckExternalLink } from 'hook/useCheckExternalLink/useCheckExternalLink';

const ProductContent = ({ dataNotify }) => {
  const { useMutationAPI } = useCustomMutate();
  const { mutate: mutateExternalLink } = useMutationAPI({
    api: externalLink,
    refetchKey: 'externalLink',
    isShowMessage: false,
  });

  return (
    <div style={{ width: '100%' }}>
      {dataNotify?.product?.image && (
        <LogoViewer
          imageUrl={dataNotify?.product?.image}
          content={`${dataNotify?.product?.productContent !== ' '}`}
        />
      )}
      {dataNotify?.product?.productContent && (
        <TextWrapper image={`${!!dataNotify?.product?.image}`}>
          <Text
            onClick={(event) => {
              const linkElement = event.target.closest('a');
              if (linkElement) {
                const href = linkElement.getAttribute('href');
                const payload = {
                  externalUrl: href,
                  productId: dataNotify?.product?.productId,
                  productName: dataNotify?.product?.productName,
                };
                if (CheckExternalLink(href)) {
                  mutateExternalLink(payload);
                }
              }
            }}
            dangerouslySetInnerHTML={{
              __html: dataNotify?.product?.productContent,
            }}
          />
        </TextWrapper>
      )}
    </div>
  );
};
export default ProductContent;
